import { Fund } from "source/giving/donate/form/types"

interface DonationFundFilterProps {
  donationFunds: Fund[]
  activeDonationFund: Fund | null
  onChange: (fund: Fund | null) => void
}

export default function DonationFundFilter({
  donationFunds,
  activeDonationFund,
  onChange,
}: DonationFundFilterProps) {
  const handleFundChange = (fundSlug: string) => {
    const selectedFund =
      fundSlug === "allFunds"
        ? null
        : donationFunds.find((fund) => fund.slug === fundSlug)!
    onChange(selectedFund)
  }

  return (
    <select
      className="select ta-l w-50%@md"
      value={activeDonationFund?.slug ?? "allFunds"}
      onChange={(e) => handleFundChange(e.target.value)}
    >
      <option value="allFunds">All funds</option>
      {donationFunds.map((fund) => (
        <option key={fund.slug} value={fund.slug}>
          {fund.name}
        </option>
      ))}
    </select>
  )
}
